<template>
  <div class="flex flex-col bg-black" :class="[isMobileDevice ? '' : 'min-h-[100vh]', isAnimating ? 'overflow-hidden' : '']">
    <Header />

    <!-- Mobile version -->
    <div
      class="new_lg:hidden px-3 new_sm:px-4 flex flex-col gap-4 box-border font-basic bg-black new_md:mt-[80px] mt-[72px] py-4"
      :class="[isAnimating ? 'overflow-hidden' : '']"
    >
      <!-- LEADWALK Hero -->
      <LeadwalkHero :motion-delay="0" />

      <!-- Service Cards Row (가로로 3개) -->
      <!-- <div class="hidden gap-4 new_md:flex bg-black">
        <ServiceCard
          v-for="(service, index) in services"
          :key="service.id"
          v-bind="service"
          :bg-color="service.id === 'testing' ? 'rgb(238, 204, 75)' : service.id === 'geteyes' ? 'rgb(156, 134, 184)' : 'rgb(105, 183, 175)'"
          :text-color="service.id === 'testing' ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)'"
          :icon="service.id === 'testing' ? require('@/assets/ic-arrow-diagonal-black.png') : require('@/assets/ic-arrow-diagonal-white.png')"
          :motion-delay="100 * (index + 1)"
        />
      </div> -->

      <!-- Review Card -->
      <ReviewCard
        :motion-delay="100"
      />

      <div class="grid grid-cols-2 new_md:grid-cols-3 w-full new_sm:gap-4 gap-3">
        <ServiceCard
          class="min-h-[calc(50vw-2.25rem)] new_sm:min-h-[calc(50vw-3rem)] new_md:min-h-[calc(33vw-4rem)]"
          v-for="(service, index) in services"
          :key="service.id"
          v-bind="service"
          :bg-color="service.id === 'testing' ? 'rgb(238, 204, 75)' : service.id === 'geteyes' ? 'rgb(156, 134, 184)' : 'rgb(105, 183, 175)'"
          :text-color="service.id === 'testing' ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)'"
          :icon="service.id === 'testing' ? require('@/assets/ic-arrow-diagonal-black.png') : require('@/assets/ic-arrow-diagonal-white.png')"
          :motion-delay="100 + (100 * (index + 1))"
        />

        <ContactCard class="min-h-[calc(50vw-1.5rem)] new_sm:min-h-[calc(50vw-3rem)] new_md:min-h-[calc(33vw-4rem)]" :motion-delay="500" />
      </div>

    </div>

    <!-- Desktop version -->
    <div
      class="px-8 w-full max-w-[1920px] h-[100vh] max-h-[1080px] pt-24 pb-4 hidden new_lg:grid grid-cols-4 grid-rows-6 mx-auto gap-6 box-border bg-black"
      :class="isAnimating ? 'overflow-hidden' : ''"
    >
      <!-- LEADWALK Hero Section -->
      <LeadwalkHero :motion-delay="0" />

      <!-- Review Card -->
      <ReviewCard :motion-delay="300 + (100 * services.length)" />

      <!-- Contact Card -->
      <ContactCard :motion-delay="100" />

        <!-- Service Cards -->
      <ServiceCard
        v-for="(service, index) in services"
        :key="service.id"
        v-bind="service"
        :bg-color="service.id === 'testing' ? 'rgb(238, 204, 75)' : service.id === 'geteyes' ? 'rgb(156, 134, 184)' : 'rgb(105, 183, 175)'"
        :text-color="service.id === 'testing' ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)'"
        :icon="service.id === 'testing' ? require('@/assets/ic-arrow-diagonal-black.png') : require('@/assets/ic-arrow-diagonal-white.png')"
        :class="[
          'row-start-5 row-end-[12]',
          service.id === 'testing' ? 'col-start-1 col-end-2' : '',
          service.id === 'geteyes' ? 'col-start-2 col-end-3' : '',
          service.id === 'qmeet' ? 'col-start-3 col-end-4' : ''
        ]"
        :motion-delay="200 + (index * 100)"
      />

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Header from '@/components/layoutComponents/Header.vue'
import LeadwalkHero from '@/components/home/LeadwalkHero.vue'
import ServiceCard from '@/components/home/ServiceCard.vue'
import ReviewCard from '@/components/home/ReviewCard.vue'
import ContactCard from '@/components/home/ContactCard.vue'
import { useHomeData } from '@/composables/useHomeData'
import { useResponsive } from '@/composables/useResponsive'

// Data
const { services } = useHomeData()

// Responsive state
const { isMobileDevice } = useResponsive()

// Animation state
const isAnimating = ref(true)

// 애니메이션이 끝나면 overflow를 해제
// 가장 긴 애니메이션 시간을 계산: delay (500ms for ContactCard) + duration (500ms) + buffer (100ms)
onMounted(() => {
  setTimeout(() => {
    isAnimating.value = false
  }, 1100) // 500ms delay + 500ms duration + 100ms buffer
})
</script>
